import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Radio, Select, Modal, Tooltip, Carousel, Image, Input, Button, Form, DatePicker, Checkbox, notification } from 'antd';
import moment from 'moment';
import Axios from 'axios';
import LS_SERVICE from '../../../utils/localStorage';
import { 
  RISK_FACTORS_LIST,
  RELATIONSHIP_TO_PP_BRIM,
  FETAL_MOVEMENT,
  PRESENTATION,
  Save_Menstrual_History,
  Save_Sexual_History,
  Save_Obstetric_History,
  Save_Obs_Gyane_Data,
  Save_Mother_Parameter_Data,
  Save_Mother_Fetus_Data,
  Get_Obs_Gyane_Data,
  Get_Previous_Obs_Gyane_Data,
  Update_Obs_Gyane_Copy_Status,
  Get_Obs_Gyane_Copy_Status,
  Get_Anc_Previous_Details,
} from '../../../utils/constant';
import { speechService, speechTextService } from '../../../utils/rxjs-sharing';
import MyHcSpeechRecognition from "../../../pages/speech-to-text/speech-recognition";

const { Option } = Select;

const { TextArea } = Input;



class ObsGynaeComponentSS extends Component {

	constructor(props) {
		super(props);
    this.obsGyaneFormRef = React.createRef();
		this.state = {
			sinceByList: [
        {id: 1, desc: 'Days'},
        {id: 2, desc: 'Weeks'},
        {id: 3, desc: 'Months'},
        {id: 4, desc: 'Years'}
      ],
      speech: {
        identifier: null,
        state: false
      },
      patient_dob : LS_SERVICE.get('call_patient_detail').age,
      pregnant : "0",
      edd_by_lmp : null,
      corrected_edd : null,
      lactating : '0',
      gestational_age_by_lmp_weeks : null,
      gestational_age_by_lmp_days : null,
      gestational_age_by_usg_weeks: null,
      gestational_age_by_usg_days : null,
      pregnancy_risk_factor : [],
      pregnancy_risk_factor_selected: [],
      pregnancy_risk_factor_management_remarks : null,
      any_previous_complications : '0',
      any_previous_complication_details : [],
      obstetric_remarks : null,
      menarch_age : null,
      regularity : null,
      lmp : null,
      bleeding_days : null,
      cycle_length : null,
      menstrual_remarks : null,
      sexually_active : '1',
      since : null,
      since_by : 1,
      married_life : null,
      contraceptives : [],
      confirmed_by : [],
      contraceptive_remarks : null,
      remarks : null,
      sexual_history_data_confidential : '0',
      mother_fetal_print_with_prescription : '0',
      remarks_confidential : '0',
      gravidity : null,
      parity : null,
      abortion : null,
      live_birth : null,
      ectopic : null,
      lscs : null,
      miscarriage : null,
      mtp : null,
      preterm : null,
      term : null,
      still_birth : null,
      obstetric_data_confidential : '0',
      mother_pog : null,
      mother_weight : null,
      mother_blood_pressure : null,
      mother_pulse_rate : null,
      mother_fundal_height : null,
      mother_edema : null,
      mother_pallor : null,
      mother_cervix_exam : null,
      mother_preterm_labour : null,
      no_of_fetus : 0,
      mother_fetal_parameters: [],
      menstrual_change_detected : false,
      sexual_change_detected : false,
      obstetric_change_detected : false,
      mother_parameter_change_detected : false,
      mother_fetus_change_detected : false,
      obs_gyane_change_detected : false,
      vitalsData: this.props.vitalsData,
      prevRecordedObsGynaePopupVisible: false,
      obsGynaePrevData : [],
      prevPregnencyCopied : false,
      allowEdit: props.allowEdit,
      prevAncCardData : []
		};
	}

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.vitalsData !== prevState.vitalsData) {
        return { vitalsData: nextProps.vitalsData }
    }
    return null;
  }

	async componentDidMount() {
    await this.optionRiskFactorsList();
    await this.updateVitals();
    const ss_configuration = LS_SERVICE.get('ss_configuration');
    const patient_full_data = LS_SERVICE.get('call_patient_detail');
    await this.setState({
        ss_configuration: ss_configuration,
        consult_type: patient_full_data?.consult_type == 1 ? 'vc' : 'opd'
    })
    this.subscription = speechTextService.status().subscribe(data => {
      if (this.state.speech.state) {
        if (this.state.speech.identifier === 'menstrual_remarks') {
          this.setState({ menstrual_remarks: data.text, menstrual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ menstrual_remarks: data.text });
        }
        if (this.state.speech.identifier === 'married_life') {
          this.setState({ married_life: data.text, sexual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ married_life: data.text });
        }
        if (this.state.speech.identifier === 'contraceptive_remarks') {
          this.setState({ contraceptive_remarks: data.text, sexual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ contraceptive_remarks: data.text });
        }
        if (this.state.speech.identifier === 'remarks') {
          this.setState({ remarks: data.text, sexual_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ remarks: data.text });
        }
        if (this.state.speech.identifier === 'pregnancy_risk_factor_management_remarks') {
          this.setState({ pregnancy_risk_factor_management_remarks: data.text, obs_gyane_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ pregnancy_risk_factor_management_remarks: data.text });
        }
        if (this.state.speech.identifier === 'obstetric_remarks') {
          this.setState({ obstetric_remarks: data.text, obs_gyane_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ obstetric_remarks: data.text });
        }
        if (this.state.speech.identifier === 'mother_remarks') {
          this.setState({ mother_remarks: data.text, mother_parameter_change_detected: true });
          this.obsGyaneFormRef.current.setFieldsValue({ mother_remarks: data.text });
        }
        document.querySelector("#" + this.state.speech.identifier).style.height = document.querySelector("#" + this.state.speech.identifier).scrollHeight + "px";
      }
    });
    await this.getPatientObsGyaneData();
    await this.getPatientObsGyaneCopyStatus();
    await this.getPatientPreviousObsGyaneData();
    await this.prevRecordedObsGynae();
    await this.getPatientAncPreviousDetails();
	}

  prevRecordedObsGynae = async (e, type) => {
    if(LS_SERVICE.get('call_patient_detail')?.gender == 'Female' && this.state.obsGynaePrevData?.pregnant == "1" && this.state.prevPregnencyCopied == false)
    {
      this.copyPrevRecordedObsGynae('Y')
      /************************ Not required popup now data auto copied *************************/
      // this.setState({
      //   prevRecordedObsGynaePopupVisible: true
      // })
    }
    else
    {
      this.copyPrevRecordedObsGynae('N')
    }
  }

  closePopup = async (e, type) => {
    if(type == 'prevRecordedObsGynae'){
      await this.setState({
        prevRecordedObsGynaePopupVisible : false
      })
    }
    if(type == 'obsHistoryList'){
      await this.setState({
        previousPregnancyDetailsModal : false
      })
    }
  }

  getPatientAncPreviousDetails = async () => {
    let Params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      current_reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      // reference_type: 0,
      // hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      // source: 'OP',  // Patient Specific Data
    }
    await Axios.post(Get_Anc_Previous_Details,Params).then(async res => {
    if(res.data.status == true)
    {
      await this.setState({
        prevAncCardData : res.data.data
      })
    }
    else
    {
      await this.setState({
        prevAncCardData : []
      })
    }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to fetch the data',
        placement: 'topRight'
      })
    })
  }

  copyPrevRecordedObsGynae = async (value) => {
    var obsGynaePrevData = this.state.obsGynaePrevData;
    if(value == 'Y'){
      /*********************** Menstural Data Fetch ****************************/
      let menstural_data = obsGynaePrevData.menstural_data;
      if(menstural_data)
      {
        await this.setState({
          menarch_age : menstural_data?.menarch_age || null,
          regularity : menstural_data?.regularity || null,
          lmp : (menstural_data?.lmp && menstural_data.lmp != null) ? moment(menstural_data.lmp).format('YYYY-MM-DD'): null,
          bleeding_days : menstural_data?.bleeding_days,
          cycle_length : menstural_data?.cycle_length,
          menstrual_remarks : menstural_data?.menstrual_remarks || null,
        });

        await this.obsGyaneFormRef.current.setFieldsValue({
          menarch_age : menstural_data?.menarch_age || null,
          regularity : menstural_data?.regularity || null,
          lmp : (menstural_data?.lmp && menstural_data.lmp != null) ? moment(menstural_data.lmp): null,
          bleeding_days : menstural_data?.bleeding_days,
          cycle_length : menstural_data?.cycle_length,
          menstrual_remarks : menstural_data?.menstrual_remarks || null,
        });
      }

      /*********************** Sexual Data Fetch ****************************/
      let sexual_data = obsGynaePrevData.sexual_data;
      if(sexual_data)
      {
        await this.setState({
          sexually_active : sexual_data?.sexually_active || null,
          since : sexual_data?.since,
          since_by : sexual_data?.since_by || 1,
          married_life : sexual_data?.married_life || null,
          contraceptives : (sexual_data?.contraceptives && sexual_data?.contraceptives != "" && sexual_data?.contraceptives != null) ? sexual_data.contraceptives.split(','): [],
          contraceptive_remarks : sexual_data?.contraceptive_remarks || null,
          remarks : sexual_data?.remarks || null,
          sexual_history_data_confidential : sexual_data?.sexual_history_data_confidential || '0',
          remarks_confidential : sexual_data?.remarks_confidential || '0',
        });

        await this.obsGyaneFormRef.current.setFieldsValue({
          sexually_active : sexual_data?.sexually_active || null,
          since : sexual_data?.since,
          since_by : sexual_data?.since_by || 1,
          married_life : sexual_data?.married_life || null,
          contraceptives : (sexual_data?.contraceptives && sexual_data?.contraceptives != "" && sexual_data?.contraceptives != null) ? sexual_data.contraceptives.split(','): [],
          contraceptive_remarks : sexual_data?.contraceptive_remarks || null,
          remarks : sexual_data?.remarks || null,
          sexual_history_data_confidential : sexual_data?.sexual_history_data_confidential || '0',
          remarks_confidential : sexual_data?.remarks_confidential || '0',
        });
      }

      /*********************** Sexual Data Fetch ****************************/
      let obstetric_data = obsGynaePrevData.obstetric_data;
      if(obstetric_data)
      {
        await this.setState({
          gravidity : obstetric_data?.gravidity,
          parity : obstetric_data?.parity,
          abortion : obstetric_data?.abortion,
          live_birth : obstetric_data?.live_birth,
          ectopic : obstetric_data?.ectopic,
          lscs : obstetric_data?.lscs,
          miscarriage : obstetric_data?.miscarriage,
          mtp : obstetric_data?.mtp,
          preterm : obstetric_data?.preterm,
          term : obstetric_data?.term,
          still_birth : obstetric_data?.still_birth,
          obstetric_data_confidential : obstetric_data?.confidential || '0',
        });

        await this.obsGyaneFormRef.current.setFieldsValue({
          gravidity : obstetric_data?.gravidity,
          parity : obstetric_data?.parity,
          abortion : obstetric_data?.abortion,
          live_birth : obstetric_data?.live_birth,
          ectopic : obstetric_data?.ectopic,
          lscs : obstetric_data?.lscs,
          miscarriage : obstetric_data?.miscarriage,
          mtp : obstetric_data?.mtp,
          preterm : obstetric_data?.preterm,
          term : obstetric_data?.term,
          still_birth : obstetric_data?.still_birth,
          obstetric_data_confidential : obstetric_data?.confidential || '0',
        });
      }

      /*********************** Obs Gyane Data Fetch ****************************/
      let obs_gyane_data = obsGynaePrevData;
      if(obs_gyane_data)
      {
        if(obs_gyane_data?.pregnancy_risk_factor != null && obs_gyane_data?.pregnancy_risk_factor != null != "")
        {
          let pregnancy_risk_factor_saved = obs_gyane_data?.pregnancy_risk_factor.split(',');
          let pregnancy_risk_factor_selected = [];
          for (var i = 0; i < pregnancy_risk_factor_saved.length; i++) {
              pregnancy_risk_factor_selected.push(parseInt(pregnancy_risk_factor_saved[i]));
          }
          await this.setState({
              pregnancy_risk_factor : pregnancy_risk_factor_selected,
              pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
          });
          await this.obsGyaneFormRef.current.setFieldsValue({
              pregnancy_risk_factor : pregnancy_risk_factor_selected,
              pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
          });
        }
        await this.setState({
          pregnant : obs_gyane_data?.pregnant || '0',
          lactating : obs_gyane_data?.lactating || '0',
          pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
          any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
          any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
          obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
        });

        await this.obsGyaneFormRef.current.setFieldsValue({
          pregnant : obs_gyane_data?.pregnant || '0',
          lactating : obs_gyane_data?.lactating || '0',
          pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
          any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
          any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
          obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
        });
      }

      let mother_parameter_data = obsGynaePrevData.mother_parameter_data;
      await this.setState({
        no_of_fetus : obs_gyane_data?.no_of_fetus || null,
        corrected_edd : (obs_gyane_data?.corrected_edd && obs_gyane_data.corrected_edd != null) ? moment(obs_gyane_data.corrected_edd).format('YYYY-MM-DD'): null,
        edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp).format('YYYY-MM-DD'): null,
        confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
        gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
        gestational_age_by_usg_days : obs_gyane_data?.gestational_age_by_usg_days,
        gestational_age_by_usg_weeks : obs_gyane_data?.gestational_age_by_usg_weeks,
        mother_pog : mother_parameter_data?.pog || null,
        mother_weight : mother_parameter_data?.weight || null,
        mother_blood_pressure : mother_parameter_data?.blood_pressure || null,
        mother_pulse_rate : mother_parameter_data?.pulse_rate || null,
        mother_fundal_height : mother_parameter_data?.fundal_height || null,
        mother_edema : mother_parameter_data?.edema || null,
        mother_pallor : mother_parameter_data?.pallor || null,
        mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
        mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
        mother_remarks : mother_parameter_data?.mother_remarks || null,
        mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
      });

      await this.obsGyaneFormRef.current.setFieldsValue({
        no_of_fetus : obs_gyane_data?.no_of_fetus || null,
        corrected_edd : (obs_gyane_data?.corrected_edd && obs_gyane_data.corrected_edd != null) ? moment(obs_gyane_data.corrected_edd): null,
        edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp): null,
        confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
        gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
        gestational_age_by_usg_days : obs_gyane_data?.gestational_age_by_usg_days,
        gestational_age_by_usg_weeks : obs_gyane_data?.gestational_age_by_usg_weeks,
        mother_pog : mother_parameter_data?.pog || null,
        mother_weight : mother_parameter_data?.weight || null,
        mother_blood_pressure : mother_parameter_data?.blood_pressure || null,
        mother_pulse_rate : mother_parameter_data?.pulse_rate || null,
        mother_fundal_height : mother_parameter_data?.fundal_height || null,
        mother_edema : mother_parameter_data?.edema || null,
        mother_pallor : mother_parameter_data?.pallor || null,
        mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
        mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
        mother_remarks : mother_parameter_data?.mother_remarks || null,
        mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
      });

      /******************** Mother Fetus Data Fetch ******************************/

      let mother_fetus_data = obsGynaePrevData?.mother_fetus_data;
      let mother_fetal_parameters = [];
      if(mother_fetus_data.length > 0)
      {
        mother_fetus_data.forEach(ele => {
          let obj = { fetal_movement: ele.fetal_movement, fetal_heart_rate: ele.fetal_heart_rate, presentation: ele.presentation, relationship_of_pp_to_brim: ele.relationship_of_pp_to_brim, head_cc: ele.head_cc, abdominal_cc: ele.abdominal_cc, femur_length: ele.femur_length }
          mother_fetal_parameters.push(obj);
        });

        await this.setState({
          mother_fetal_parameters : mother_fetal_parameters,
        });

        await this.obsGyaneFormRef.current.setFieldsValue({
          mother_fetal_parameters : mother_fetal_parameters,
        });
      }

      this.handleSaveObsGyaneData();
      this.handleSaveMenstrualHistory();
      this.handleSaveSexualHistory();
      this.handleSaveObstetricHistory();
      this.handleSaveMotherParameterData();
      this.handleSaveMotherFetusData();
    }
    var params = {
      reference_id: LS_SERVICE.get('call_patient_qms_token_id'),
      reference_type: LS_SERVICE.get('reference_type'),
      status: value
    }
    await Axios.post(Update_Obs_Gyane_Copy_Status, params);
    // this.closePopup(e, 'prevRecordedObsGynae')
  }


  async updateVitals(){
    if((this.props?.vitalsData?.V005 && this.props?.vitalsData?.V005 > 0) || (this.props?.vitalsData?.V006 && this.props?.vitalsData?.V006 > 0)){
      await this.setState({
        mother_blood_pressure : this.props?.vitalsData?.V006+'/'+this.props?.vitalsData?.V005
      })
      this.obsGyaneFormRef.current.setFieldsValue({
        mother_blood_pressure : this.props?.vitalsData?.V006+'/'+this.props?.vitalsData?.V005
      });
    }

    if(this.props?.vitalsData?.V009 && this.props?.vitalsData?.V009 > 0){
      await this.setState({
        mother_pulse_rate : this.props?.vitalsData?.V009
      })
      this.obsGyaneFormRef.current.setFieldsValue({
        mother_pulse_rate : this.props?.vitalsData?.V009
      });
    }

    if(this.props?.vitalsData?.V002 && this.props?.vitalsData?.V002 > 0){
      await this.setState({
        mother_weight : this.props?.vitalsData?.V002
      })
      this.obsGyaneFormRef.current.setFieldsValue({
        mother_weight : this.props?.vitalsData?.V002
      });
    }
  }

  saveObsGyaneData = async() => {
    this.handleSaveObsGyaneData();
    this.handleSaveMenstrualHistory();
    this.handleSaveSexualHistory();
    this.handleSaveObstetricHistory();
    this.handleSaveMotherParameterData();
    this.handleSaveMotherFetusData();
  }

  getPatientObsGyaneData = async () => {
    let Params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }
    await Axios.post(Get_Obs_Gyane_Data,Params).then(async res => {
      if(res.data.status == true)
      {
        /*********************** Menstural Data Fetch ****************************/
        let menstural_data = res.data?.data?.menstural_data;
        if(menstural_data)
        {
          await this.setState({
            menarch_age : menstural_data?.menarch_age || null,
            regularity : menstural_data?.regularity || null,
            lmp : (menstural_data?.lmp && menstural_data.lmp != null) ? moment(menstural_data.lmp).format('YYYY-MM-DD'): null,
            bleeding_days : menstural_data?.bleeding_days,
            cycle_length : menstural_data?.cycle_length,
            menstrual_remarks : menstural_data?.menstrual_remarks || null,
          });

          await this.obsGyaneFormRef.current.setFieldsValue({
            menarch_age : menstural_data?.menarch_age || null,
            regularity : menstural_data?.regularity || null,
            lmp : (menstural_data?.lmp && menstural_data.lmp != null) ? moment(menstural_data.lmp): null,
            bleeding_days : menstural_data?.bleeding_days,
            cycle_length : menstural_data?.cycle_length,
            menstrual_remarks : menstural_data?.menstrual_remarks || null,
          });
        }

        /*********************** Sexual Data Fetch ****************************/
        let sexual_data = res.data?.data?.sexual_data;
        if(sexual_data)
        {
          await this.setState({
            sexually_active : sexual_data?.sexually_active || null,
            since : sexual_data?.since,
            since_by : sexual_data?.since_by || 1,
            married_life : sexual_data?.married_life || null,
            contraceptives : (sexual_data?.contraceptives && sexual_data?.contraceptives != "" && sexual_data?.contraceptives != null) ? sexual_data.contraceptives.split(','): [],
            contraceptive_remarks : sexual_data?.contraceptive_remarks || null,
            remarks : sexual_data?.remarks || null,
            sexual_history_data_confidential : sexual_data?.sexual_history_data_confidential || '0',
            remarks_confidential : sexual_data?.remarks_confidential || '0',
          });

          await this.obsGyaneFormRef.current.setFieldsValue({
            sexually_active : sexual_data?.sexually_active || null,
            since : sexual_data?.since,
            since_by : sexual_data?.since_by || 1,
            married_life : sexual_data?.married_life || null,
            contraceptives : (sexual_data?.contraceptives && sexual_data?.contraceptives != "" && sexual_data?.contraceptives != null) ? sexual_data.contraceptives.split(','): [],
            contraceptive_remarks : sexual_data?.contraceptive_remarks || null,
            remarks : sexual_data?.remarks || null,
            sexual_history_data_confidential : sexual_data?.sexual_history_data_confidential || '0',
            remarks_confidential : sexual_data?.remarks_confidential || '0',
          });
        }

        /*********************** Sexual Data Fetch ****************************/
        let obstetric_data = res.data?.data?.obstetric_data;
        if(obstetric_data)
        {
          await this.setState({
            gravidity : obstetric_data?.gravidity,
            parity : obstetric_data?.parity,
            abortion : obstetric_data?.abortion,
            live_birth : obstetric_data?.live_birth,
            ectopic : obstetric_data?.ectopic,
            lscs : obstetric_data?.lscs,
            miscarriage : obstetric_data?.miscarriage,
            mtp : obstetric_data?.mtp,
            preterm : obstetric_data?.preterm,
            term : obstetric_data?.term,
            still_birth : obstetric_data?.still_birth,
            obstetric_data_confidential : obstetric_data?.confidential || '0',
          });

          await this.obsGyaneFormRef.current.setFieldsValue({
            gravidity : obstetric_data?.gravidity,
            parity : obstetric_data?.parity,
            abortion : obstetric_data?.abortion,
            live_birth : obstetric_data?.live_birth,
            ectopic : obstetric_data?.ectopic,
            lscs : obstetric_data?.lscs,
            miscarriage : obstetric_data?.miscarriage,
            mtp : obstetric_data?.mtp,
            preterm : obstetric_data?.preterm,
            term : obstetric_data?.term,
            still_birth : obstetric_data?.still_birth,
            obstetric_data_confidential : obstetric_data?.confidential || '0',
          });
        }

        /*********************** Obs Gyane Data Fetch ****************************/
        let obs_gyane_data = res.data?.data;
        if(obs_gyane_data)
        {
          if(obs_gyane_data?.pregnancy_risk_factor != null && obs_gyane_data?.pregnancy_risk_factor != null != "")
          {
            let pregnancy_risk_factor_saved = obs_gyane_data?.pregnancy_risk_factor.split(',');
            let pregnancy_risk_factor_selected = [];
            for (var i = 0; i < pregnancy_risk_factor_saved.length; i++) {
                pregnancy_risk_factor_selected.push(parseInt(pregnancy_risk_factor_saved[i]));
            }
            await this.setState({
                pregnancy_risk_factor : pregnancy_risk_factor_selected,
                pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
            });
            await this.obsGyaneFormRef.current.setFieldsValue({
                pregnancy_risk_factor : pregnancy_risk_factor_selected,
                pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
            });
          }
          await this.setState({
            pregnant : obs_gyane_data?.pregnant || '0',
            lactating : obs_gyane_data?.lactating || '0',
            pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
            any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
            any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
            obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
          });

          await this.obsGyaneFormRef.current.setFieldsValue({
            pregnant : obs_gyane_data?.pregnant || '0',
            lactating : obs_gyane_data?.lactating || '0',
            pregnancy_risk_factor_management_remarks : obs_gyane_data?.pregnancy_risk_factor_management_remarks || null,
            any_previous_complications : obs_gyane_data?.any_previous_complications || '0',
            any_previous_complication_details : (obs_gyane_data?.any_previous_complication_details && obs_gyane_data?.any_previous_complication_details != "" && obs_gyane_data?.any_previous_complication_details != null) ? obs_gyane_data.any_previous_complication_details.split(','): [],
            obstetric_remarks : obs_gyane_data?.obstetric_remarks || null,
          });
        }

        if(obs_gyane_data.pregnant == "1")
        {
          let mother_parameter_data = res.data?.data?.mother_parameter_data;
          await this.setState({
            no_of_fetus : obs_gyane_data?.no_of_fetus || null,
            corrected_edd : (obs_gyane_data?.corrected_edd && obs_gyane_data.corrected_edd != null) ? moment(obs_gyane_data.corrected_edd).format('YYYY-MM-DD'): null,
            edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp).format('YYYY-MM-DD'): null,
            confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
            gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
            gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
            gestational_age_by_usg_days : obs_gyane_data?.gestational_age_by_usg_days,
            gestational_age_by_usg_weeks : obs_gyane_data?.gestational_age_by_usg_weeks,
            mother_pog : mother_parameter_data?.pog || null,
            mother_weight : mother_parameter_data?.weight || null,
            mother_blood_pressure : mother_parameter_data?.blood_pressure || null,
            mother_pulse_rate : mother_parameter_data?.pulse_rate || null,
            mother_fundal_height : mother_parameter_data?.fundal_height || null,
            mother_edema : mother_parameter_data?.edema || null,
            mother_pallor : mother_parameter_data?.pallor || null,
            mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
            mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
            mother_remarks : mother_parameter_data?.mother_remarks || null,
            mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
          });

          await this.obsGyaneFormRef.current.setFieldsValue({
            no_of_fetus : obs_gyane_data?.no_of_fetus || null,
            corrected_edd : (obs_gyane_data?.corrected_edd && obs_gyane_data.corrected_edd != null) ? moment(obs_gyane_data.corrected_edd): null,
            edd_by_lmp : (obs_gyane_data?.edd_by_lmp && obs_gyane_data.edd_by_lmp != null) ? moment(obs_gyane_data.edd_by_lmp): null,
            confirmed_by : (obs_gyane_data?.confirmed_by && obs_gyane_data?.confirmed_by != "" && obs_gyane_data?.confirmed_by != null) ? obs_gyane_data.confirmed_by.split(','): [],
            gestational_age_by_lmp_weeks : obs_gyane_data?.gestational_age_by_lmp_weeks,
            gestational_age_by_lmp_days : obs_gyane_data?.gestational_age_by_lmp_days,
            gestational_age_by_usg_days : obs_gyane_data?.gestational_age_by_usg_days,
            gestational_age_by_usg_weeks : obs_gyane_data?.gestational_age_by_usg_weeks,
            mother_pog : mother_parameter_data?.pog || null,
            mother_weight : mother_parameter_data?.weight || null,
            mother_blood_pressure : mother_parameter_data?.blood_pressure || null,
            mother_pulse_rate : mother_parameter_data?.pulse_rate || null,
            mother_fundal_height : mother_parameter_data?.fundal_height || null,
            mother_edema : mother_parameter_data?.edema || null,
            mother_pallor : mother_parameter_data?.pallor || null,
            mother_cervix_exam : mother_parameter_data?.cervix_exam || null,
            mother_preterm_labour : mother_parameter_data?.preterm_labour || null,
            mother_remarks : mother_parameter_data?.mother_remarks || null,
            mother_fetal_print_with_prescription : obs_gyane_data?.mother_fetal_print_with_prescription || '0',
          });

          /******************** Mother Fetus Data Fetch ******************************/

          let mother_fetus_data = res.data?.data?.mother_fetus_data;
          let mother_fetal_parameters = [];
          if(mother_fetus_data.length > 0)
          {
            mother_fetus_data.forEach(ele => {
              let obj = { fetal_movement: ele.fetal_movement, fetal_heart_rate: ele.fetal_heart_rate, presentation: ele.presentation, relationship_of_pp_to_brim: ele.relationship_of_pp_to_brim, head_cc: ele.head_cc, abdominal_cc: ele.abdominal_cc, femur_length: ele.femur_length }
              mother_fetal_parameters.push(obj);
            });

            await this.setState({
              mother_fetal_parameters : mother_fetal_parameters,
            });

            await this.obsGyaneFormRef.current.setFieldsValue({
              mother_fetal_parameters : mother_fetal_parameters,
            });
          }
        }
        else
        {
          await this.setState({
            mother_pog : null,
            no_of_fetus : null,
            corrected_edd : null,
            edd_by_lmp : null,
            confirmed_by : [],
            gestational_age_by_lmp_weeks : null,
            gestational_age_by_lmp_days : null,
            gestational_age_by_usg_days : null,
            gestational_age_by_usg_weeks : null,
            mother_pog : null,
            mother_weight : null,
            mother_blood_pressure : null,
            mother_pulse_rate : null,
            mother_fundal_height : null,
            mother_edema : null,
            mother_pallor : null,
            mother_cervix_exam : null,
            mother_preterm_labour : null,
            mother_fetal_parameters : [],
            mother_remarks : null,
            mother_fetal_print_with_prescription : '0'
          });
          await this.obsGyaneFormRef.current.setFieldsValue({
            mother_pog : null,
            no_of_fetus : null,
            corrected_edd : null,
            edd_by_lmp : null,
            gestational_age_by_lmp_weeks : null,
            gestational_age_by_lmp_days : null,
            gestational_age_by_usg_days : null,
            gestational_age_by_usg_weeks : null,
            mother_pog : null,
            mother_weight : null,
            mother_blood_pressure : null,
            mother_pulse_rate : null,
            mother_fundal_height : null,
            mother_edema : null,
            mother_pallor : null,
            mother_cervix_exam : null,
            mother_preterm_labour : null,
            mother_remarks : null,
            mother_fetal_print_with_prescription : '0'
          });
        }
        
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to fetch the data',
        placement: 'topRight'
      })
    })
  }

  getPatientObsGyaneCopyStatus = async () => {
    let Params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
    }
    await Axios.post(Get_Obs_Gyane_Copy_Status,Params).then(async res => {
      if(res.data.status == true)
      {
        await this.setState({
          prevPregnencyCopied : res.data.data.copy_prev_obs_gyane_status == '1' ? true : false
        })               
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to fetch the data',
        placement: 'topRight'
      })
    })
  }

  getPatientPreviousObsGyaneData = async () => {
    let Params = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }
    await Axios.post(Get_Previous_Obs_Gyane_Data,Params).then(async res => {
      if(res.data.status == true)
      {
        await this.setState({
          obsGynaePrevData : res.data.data
        })               
      }
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to fetch the data',
        placement: 'topRight'
      })
    })
  }
  
  async componentWillUnmount() {
    if(this.state.obs_gyane_change_detected)
    {
      this.handleSaveObsGyaneData();
    }
    if(this.state.menstrual_change_detected)
    {
      this.handleSaveMenstrualHistory();
    }
    if(this.state.sexual_change_detected)
    {
      this.handleSaveSexualHistory();
    }
    if(this.state.obstetric_change_detected)
    {
      this.handleSaveObstetricHistory();
    }
    if(this.state.mother_parameter_change_detected)
    {
      this.handleSaveMotherParameterData();
    }
    if(this.state.mother_fetus_change_detected)
    {
      this.handleSaveMotherFetusData();
    }
  }

  handleSaveMenstrualHistory = async () => {
    let menstural_data = {
      menarch_age : this.state.menarch_age,
      regularity : this.state.regularity,
      lmp : this.state.lmp != null ? moment(this.state.lmp).format('YYYY-MM-DD') : null,
      bleeding_days : this.state.bleeding_days,
      cycle_length : this.state.cycle_length,
      menstrual_remarks : this.state.menstrual_remarks,
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }
    let where_condition = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }

    let Params = {
      where_condition,
      menstural_data,
    }
    await Axios.post(Save_Menstrual_History,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveSexualHistory = async () => {
    let sexual_data = {
      sexually_active : this.state.sexually_active,
      since : this.state.since,
      since_by : this.state.since_by || 1,
      married_life : this.state.married_life,
      contraceptives : this.state.contraceptives.length > 0 ? this.state.contraceptives.toString(): null,
      contraceptive_remarks : this.state.contraceptive_remarks,
      remarks : this.state.contraceptive_remarks,
      sexual_history_data_confidential : this.state.sexual_history_data_confidential,
      remarks_confidential : this.state.remarks_confidential,
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }
    let where_condition = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }

    let Params = {
      where_condition,
      sexual_data,
    }
    await Axios.post(Save_Sexual_History,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveObstetricHistory = async () => {
    let obstetric_data = {
      gravidity : this.state.gravidity,
      parity : this.state.parity,
      abortion : this.state.abortion,
      live_birth : this.state.live_birth,
      ectopic : this.state.ectopic,
      lscs : this.state.lscs,
      miscarriage : this.state.miscarriage,
      mtp : this.state.mtp,
      preterm : parseInt(this.state.preterm),
      term : parseInt(this.state.term),
      still_birth : this.state.still_birth,
      confidential : this.state.obstetric_data_confidential,
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }
    let where_condition = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }

    let Params = {
      where_condition,
      obstetric_data,
    }
    await Axios.post(Save_Obstetric_History,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveObsGyaneData = async () => {
    let obs_gyane_data = {
      pregnant : this.state.pregnant,
      edd_by_lmp : this.state.pregnant == "1" ? this.state.edd_by_lmp : null,
      corrected_edd : this.state.pregnant == "1" ? this.state.corrected_edd : null,
      lactating : this.state.lactating,
      confirmed_by : (this.state.confirmed_by.length > 0 && this.state.pregnant == "1") ? this.state.confirmed_by.toString(): null,
      gestational_age_by_lmp_weeks : this.state.pregnant == "1" ? this.state.gestational_age_by_lmp_weeks : null,
      gestational_age_by_lmp_days : this.state.pregnant == "1" ? this.state.gestational_age_by_lmp_days : null,
      gestational_age_by_usg_weeks: this.state.pregnant == "1" ? this.state.gestational_age_by_usg_weeks : null,
      gestational_age_by_usg_days : this.state.pregnant == "1" ? this.state.gestational_age_by_usg_days : null,
      pregnancy_risk_factor : this.state.pregnancy_risk_factor.length > 0 ? this.state.pregnancy_risk_factor.toString(): null,
      pregnancy_risk_factor_management_remarks : this.state.pregnancy_risk_factor_management_remarks,
      any_previous_complications : this.state.any_previous_complications,
      any_previous_complication_details : this.state.any_previous_complication_details.length > 0 ? this.state.any_previous_complication_details.toString(): null,
      obstetric_remarks : this.state.obstetric_remarks,
      no_of_fetus : this.state.pregnant == "1" ? this.state.no_of_fetus : null,
      mother_fetal_print_with_prescription : this.state.mother_fetal_print_with_prescription || '0',
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }
    let where_condition = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }

    let Params = {
      where_condition,
      obs_gyane_data,
    }
    await Axios.post(Save_Obs_Gyane_Data,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveMotherParameterData = async () => {
    let mother_parameter_data = {
      pog : this.state.pregnant == "1" ? this.state.mother_pog : null,
      weight : this.state.pregnant == "1" ? this.state.mother_weight : null,
      blood_pressure : this.state.pregnant == "1" ? this.state.mother_blood_pressure : null,
      pulse_rate : this.state.pregnant == "1" ? this.state.mother_pulse_rate : null,
      fundal_height : this.state.pregnant == "1" ? this.state.mother_fundal_height : null,
      edema : this.state.pregnant == "1" ? this.state.mother_edema : null,
      pallor : this.state.pregnant == "1" ? this.state.mother_pallor : null,
      cervix_exam : this.state.pregnant == "1" ? this.state.mother_cervix_exam : null,
      preterm_labour : this.state.pregnant == "1" ? this.state.mother_preterm_labour : null,
      mother_remarks : this.state.pregnant == "1" ? this.state.mother_remarks : null,
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }
    let where_condition = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }

    let Params = {
      where_condition,
      mother_parameter_data,
    }
    await Axios.post(Save_Mother_Parameter_Data,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleSaveMotherFetusData = async () => {
    let mother_fetus_data = {
      mother_fetal_parameters : this.state.pregnant == "1" ? this.state.mother_fetal_parameters : [],
      created_by : LS_SERVICE.get('staff_id'),
      updated_by : LS_SERVICE.get('staff_id')
    }
    let where_condition = {
      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
      reference_type: 0,
      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
      source: 'OP',
    }

    let Params = {
      where_condition,
      mother_fetus_data,
    }
    await Axios.post(Save_Mother_Fetus_Data,Params).then(async res => {
    })
    .catch(error => {
      notification.error({
        message: 'Something went wrong! Unable to save the data',
        placement: 'topRight'
      })
    })
  }

  handleOnNumberChange = async(event) => {
    const { name, value } = event.currentTarget;
    let regex_aplhabet = /[0-9?]/
    const isValidNumber = regex_aplhabet.test(value);
    if(!isValidNumber && value != '')
    {
      return false;
    }
    await this.setState({
      [name]: value
    });

    if(name == "menarch_age" || name == "bleeding_days" || name == "cycle_length")
    {
      await this.setState({
        menstrual_change_detected : true
      })
    }
    if(name == "since")
    {
      await this.setState({
        sexual_change_detected : true
      })
    }
    if(name == "gestational_age_by_lmp_weeks" || name == "gestational_age_by_lmp_days" || name == "gestational_age_by_usg_weeks" || name == "gestational_age_by_usg_days")
    {
      await this.setState({
        obs_gyane_change_detected : true
      })
    }
    if(name == "gravidity" || name == "parity" || name == "abortion" || name == "live_birth" || name == "ectopic" || name == "lscs" || name == "miscarriage" || name == "mtp" || name == "preterm" || name == "term" || name == "still_birth")
    {
      await this.setState({
        obstetric_change_detected : true
      })
    }

    await this.obsGyaneFormRef.current.setFieldsValue({
      [name]: value
    });
  }

  onSelectChange = async (value, props, field, index) => {
    await this.setState({
      [field]: value,
      menstrual_change_detected : true
    });
    await this.obsGyaneFormRef.current.setFieldsValue({
      [field]: value
    });
  }

  onSelectSinceByChange = async (event) => {
    const { name, value } = event.currentTarget;
    await this.setState({ since_by: value , sexual_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      since_by: value
    });
  }

  handleSexualDataConfidentialChange = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ sexual_history_data_confidential: value, sexual_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      sexual_history_data_confidential: value
    });
  }

  handleObsterticDataConfidentialChange = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ obstetric_data_confidential: value, obstetric_change_detected: true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      obstetric_data_confidential: value
    });
  }

  handleMotherFetalPrintWithPrescription = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ mother_fetal_print_with_prescription: value });
    await this.obsGyaneFormRef.current.setFieldsValue({
      mother_fetal_print_with_prescription: value
    });
  }

  handleLactatingChange = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ lactating: value, obs_gyane_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      lactating: value
    });
  }

  handleSexualRemarksConfidentialChange = async (e) => {
    const checked = e.target.checked;
    const value = checked ? '1' : '0';

    await this.setState({ remarks_confidential: value , sexual_change_detected : true });
    await this.obsGyaneFormRef.current.setFieldsValue({
      remarks_confidential: value
    });
  }

  handleOnTextChange = async(event) => {
    const { name, value } = event.currentTarget;
    await this.setState({
      [name]: value
    });
    if(name == "menstrual_remarks")
    {
      await this.setState({
        menstrual_change_detected : true
      })
    }
    if(name == "married_life" || name == "contraceptive_remarks" || name == "remarks")
    {
      await this.setState({
        sexual_change_detected : true
      })
    }
    if(name == "pregnancy_risk_factor_management_remarks" || name == "obstetric_remarks")
    {
      await this.setState({
        obs_gyane_change_detected : true
      })
    }
    if(name == "mother_pog" || name == "mother_weight" || name == "mother_blood_pressure" || name == "mother_pulse_rate" || name == "mother_fundal_height" || name == "mother_edema" || name == "mother_pallor" || name == "mother_cervix_exam" || name == "mother_preterm_labour" || name == "mother_remarks")
    {
      await this.setState({
        mother_parameter_change_detected : true
      })
    }
    await this.obsGyaneFormRef.current.setFieldsValue({
      [name]: value
    });
  }

  onChangeRadioCheck = async (event) => {
    await this.setState({
        sexually_active: event.target.value,
        sexual_change_detected : true
    });

    await this.obsGyaneFormRef.current.setFieldsValue({
      sexually_active : event.target.value
    });
  }

  handleLmpDateChange = async (date, dateString, field) => {
    
    let gestational_age_by_lmp_weeks = null;
    let gestational_age_by_lmp_days = null;
    let edd_by_lmp = null;
    await this.setState({
      [field]: moment(date).format("YYYY-MM-DD"),
      menstrual_change_detected : true
    }, async () => {
      const currentDate = moment();
      const duration = moment.duration(currentDate.diff(this.state.lmp));
      gestational_age_by_lmp_weeks = Math.floor(duration.asDays() / 7);
      gestational_age_by_lmp_days = Math.round(duration.asDays() % 7);
      if(gestational_age_by_lmp_days == 7)
      {
        gestational_age_by_lmp_weeks = gestational_age_by_lmp_weeks+1;
        gestational_age_by_lmp_days = 0;
      }
      if(gestational_age_by_lmp_weeks < 0 )
      {
        gestational_age_by_lmp_weeks = 0
      }
      if(gestational_age_by_lmp_days < 0 )
      {
        gestational_age_by_lmp_days = 0
      }
      edd_by_lmp = moment(this.state.lmp).add(40, 'weeks').format("YYYY-MM-DD");
      await this.setState({
        gestational_age_by_lmp_weeks : gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_days : gestational_age_by_lmp_days,
        mother_pog : gestational_age_by_lmp_weeks,
        edd_by_lmp : moment(edd_by_lmp).format("YYYY-MM-DD"),
      });
      await this.obsGyaneFormRef.current.setFieldsValue({
        mother_pog: gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_weeks: gestational_age_by_lmp_weeks,
        gestational_age_by_lmp_days: gestational_age_by_lmp_days,
        edd_by_lmp : moment(edd_by_lmp),
      });
    });
  }

  onChangePregnantCheck = async (event) => {
    let gestational_age_by_lmp_weeks = null;
    let gestational_age_by_lmp_days = null;
    let edd_by_lmp = null;
    await this.setState({
      pregnant: event.target.value,
      obs_gyane_change_detected : true,
      mother_parameter_change_detected : true,
      mother_fetus_change_detected : true,
    }, async () => {
      if(this.state.pregnant == "1" && this.state.lmp != null)
      {
        const currentDate = moment();
        const duration = moment.duration(currentDate.diff(this.state.lmp));
        gestational_age_by_lmp_weeks = Math.floor(duration.asDays() / 7);
        gestational_age_by_lmp_days = Math.round(duration.asDays() % 7);
        if(gestational_age_by_lmp_days == 7)
        {
          gestational_age_by_lmp_weeks = gestational_age_by_lmp_weeks+1;
          gestational_age_by_lmp_days = 0;
        }
        if(gestational_age_by_lmp_weeks < 0 )
        {
          gestational_age_by_lmp_weeks = 0
        }
        if(gestational_age_by_lmp_days < 0 )
        {
          gestational_age_by_lmp_days = 0
        }
        edd_by_lmp = moment(this.state.lmp).add(40, 'weeks').format("YYYY-MM-DD");
        await this.setState({
          gestational_age_by_lmp_weeks : gestational_age_by_lmp_weeks,
          gestational_age_by_lmp_days : gestational_age_by_lmp_days,
          mother_pog : gestational_age_by_lmp_weeks,
          edd_by_lmp : moment(edd_by_lmp).format("YYYY-MM-DD"),
        });
        await this.obsGyaneFormRef.current.setFieldsValue({
          mother_pog: gestational_age_by_lmp_weeks,
          gestational_age_by_lmp_weeks: gestational_age_by_lmp_weeks,
          gestational_age_by_lmp_days: gestational_age_by_lmp_days,
          edd_by_lmp : moment(edd_by_lmp),
        });
      }
      else
      {
        await this.setState({
          mother_pog : null,
          no_of_fetus : null,
          corrected_edd : null,
          edd_by_lmp : null,
          confirmed_by : [],
          gestational_age_by_lmp_weeks : null,
          gestational_age_by_lmp_days : null,
          gestational_age_by_usg_days : null,
          gestational_age_by_usg_weeks : null,
          mother_pog : null,
          mother_weight : null,
          mother_blood_pressure : null,
          mother_pulse_rate : null,
          mother_fundal_height : null,
          mother_edema : null,
          mother_pallor : null,
          mother_cervix_exam : null,
          mother_preterm_labour : null,
          mother_fetal_parameters : [],
          mother_remarks : null,
          mother_fetal_print_with_prescription : '0'
        });
        await this.obsGyaneFormRef.current.setFieldsValue({
          mother_pog : null,
          no_of_fetus : null,
          corrected_edd : null,
          edd_by_lmp : null,
          gestational_age_by_lmp_weeks : null,
          gestational_age_by_lmp_days : null,
          gestational_age_by_usg_days : null,
          gestational_age_by_usg_weeks : null,
          mother_pog : null,
          mother_weight : null,
          mother_blood_pressure : null,
          mother_pulse_rate : null,
          mother_fundal_height : null,
          mother_edema : null,
          mother_pallor : null,
          mother_cervix_exam : null,
          mother_preterm_labour : null,
          mother_remarks : null,
          mother_fetal_print_with_prescription : '0'
        });
      }
    });

    await this.obsGyaneFormRef.current.setFieldsValue({
      pregnant : event.target.value
    });
  }

  onChangePreviousComplicationCheck = async (event) => {
    
    await this.setState({
      any_previous_complications: event.target.value,
      obs_gyane_change_detected: true
    });

    await this.obsGyaneFormRef.current.setFieldsValue({
      any_previous_complications : event.target.value
    });
  }

  handleOnPregnancyRiskFactorChange = async (val,props) => {
    // console.log(val);
    // console.log(props);
    let pregnancy_risk_factor_selected_data = [];
    await this.setState({
      pregnancy_risk_factor_selected: val,
      obs_gyane_change_detected : true
    });
    props.forEach(element => {
      pregnancy_risk_factor_selected_data.push(element.value);
    });

    await this.setState({
      pregnancy_risk_factor: pregnancy_risk_factor_selected_data.join(),
      obs_gyane_change_detected: true
    });
  }

  disabledLmpDate(current) {
    const today = moment().endOf('day');
    const tenMonthsAgo = moment().subtract(10, 'months').startOf('day');
    return current && (current > today || current < tenMonthsAgo);
    // return current && current > moment();
  }

  disableEDDDate = (current) => {
    const eddByLMP = moment(this.state.edd_by_lmp, "YYYY-MM-DD");
    const minDate = moment(eddByLMP).subtract(4, 'weeks');
    const maxDate = moment(eddByLMP).add(4, 'weeks');
    return current && (current < minDate || current > maxDate)
  }

  disableCorrectedEDDDate = (current) => {
    const eddByLMP = moment(this.state.edd_by_lmp, "YYYY-MM-DD");
    const minDate = moment(eddByLMP).subtract(4, 'weeks');
    const maxDate = moment(eddByLMP).add(4, 'weeks');
    return current && (current < minDate || current > maxDate)
  };

  handleEDDChange = async (date, dateString, field) => {
    await this.setState({
      edd_by_lmp: moment(date).format("YYYY-MM-DD"),
      obs_gyane_change_detected : true,
    })

    await this.obsGyaneFormRef.current.setFieldsValue({
      edd_by_lmp : moment(date)
    });
  };

  handleCorrectedEDDChange = async (date, dateString, field) => {
    await this.setState({
      corrected_edd: moment(date).format("YYYY-MM-DD"),
      obs_gyane_change_detected : true
    })

    await this.obsGyaneFormRef.current.setFieldsValue({
      corrected_edd : moment(date)
    });
  };

  navigateCorrectedEddDate = () => {
    const eddByLMP = moment(this.state.edd_by_lmp, "YYYY-MM-DD");
    if(moment(eddByLMP) == "Invalid date"){
      return moment()
    }
    else{
      return moment(eddByLMP)
    }
  }

  handleFetalParamsChange = async (event, field, index) => {
    event.persist();
    await this.setState(prevState => {
      const prevItems = [...prevState.mother_fetal_parameters];
      prevItems[index][field] = event.target?.value;
      return { mother_fetal_parameters: prevItems };
    });
    await this.setState({
      mother_fetus_change_detected: true
    })
  }

  handleFetalParamsSelectChange = async (value, props, field, index) => {
    await this.setState(prevState => {
      const prevItems = [...prevState.mother_fetal_parameters];
      prevItems[index][field] = value;
      return { mother_fetal_parameters: prevItems };
    });
    await this.setState({
      mother_fetus_change_detected: true
    })
  }

  handleContraceptivesChange = async (e, val) => {
    try {
      let contraceptives_selected_data = [];
      if (val === '1') { // If 'None' checkbox is selected
          contraceptives_selected_data = e.target.checked ? [val] : [];
      } else {
          contraceptives_selected_data = Array.isArray(this.state.contraceptives)
              ? [...this.state.contraceptives]
              : [];
          if (e.target.checked) {
              contraceptives_selected_data.push(val);
          } else {
              contraceptives_selected_data = contraceptives_selected_data.filter(item => item !== val);
          }
          // If 'None' was previously selected, unselect it
          contraceptives_selected_data = contraceptives_selected_data.filter(item => item !== '1');
      }

      await this.setState({ contraceptives : contraceptives_selected_data , sexual_change_detected : true });
    } catch (error) {
        console.error("Error occurred in handleContraceptivesChange:", error);
    }
  }

  handleConfirmedByChange = async (e, val) => {
    let updatedConfirmedDone = [...this.state.confirmed_by];
    if (e.target.checked) {
      updatedConfirmedDone.push(val);
    } else {
      // If checkbox is unchecked, remove the value from the array
      updatedConfirmedDone = updatedConfirmedDone.filter(item => item != val);
    }
    // Update the state with the new confirmed_by array
    await this.setState({ confirmed_by: updatedConfirmedDone, obs_gyane_change_detected: true });
  }

  handleComplicationDetailsChange = async (e, val) => {
    let updatedComplicationDetails = [...this.state.any_previous_complication_details];
    if (e.target.checked) {
      updatedComplicationDetails.push(val);
    } else {
      // If checkbox is unchecked, remove the value from the array
      updatedComplicationDetails = updatedComplicationDetails.filter(item => item != val);
    }
    // Update the state with the new any_previous_complication_details array
    await this.setState({ any_previous_complication_details: updatedComplicationDetails, obs_gyane_change_detected: true });

    // console.log(this.state.any_previous_complication_details);
  }

  autoHeight = (e) => {
    if(e)
    {
      e.target.style.height = e.target.scrollHeight + "px";
    }
  }

  optionRiskFactorsList() {
    Axios.get(RISK_FACTORS_LIST).then(async success => {
      if (success?.data?.status == true) {
          this.setState({ risk_factors_list: success.data.data });
      }
    }).catch(err => console.log(err));
  }

  handleFetusChange = async (no_of_fetus) => {
    var new_length = no_of_fetus;
    if(no_of_fetus > 0)
    {
      let prev_length = this.state.mother_fetal_parameters.length;
      if (new_length > prev_length) {
        let adds = new_length - prev_length;
        for (let i = 0; i < adds; i++) {
          const obj = { fetal_movement: null, fetal_heart_rate: null, presentation: null, relationship_of_pp_to_brim: null, head_cc: null, abdominal_cc: null, femur_length: null }
          await this.setState(prevState => {
            const newItems = [...prevState.mother_fetal_parameters, obj];
            return { mother_fetal_parameters: newItems };
          });
        }
      } else if (prev_length > new_length) {
        let removes = prev_length - new_length;
        let index = prev_length - 1;
        for (let i = 0; i < removes; i++) {
          let prevValues = await this.obsGyaneFormRef.current.getFieldsValue();
          await this.setState(prevState => ({
            mother_fetal_parameters: prevState.mother_fetal_parameters.filter((data, j) => j !== index)
          }));
          // await prevValues['blood_bag_master'].splice(index, 1);
          await this.obsGyaneFormRef.current.setFieldsValue({
            ...prevValues
          })
          index--;
        }
      }
    }
    await this.setState({
      no_of_fetus: no_of_fetus,
      obs_gyane_change_detected : true,
      mother_fetus_change_detected : true
    })
  }

  optionRiskFactorsLoad() {
    if (!this.state.risk_factors_list || this.state.risk_factors_list.length === 0) {
      return (<Option value={0}><span>No Result Found</span></Option>)
    }
    return this.state.risk_factors_list.map((obj, i) => {
      return (<Option key={i} value={parseInt(obj.id)} title={obj.description}>{obj.description}</Option>)
    }, this)
  }

  initSpeech = async (info) => {
    let initialText = '';
    if (info.identifier === 'menstrual_remarks') {
      initialText = this.state.menstrual_remarks != undefined ? this.state.menstrual_remarks : '';
    }
    if (info.identifier === 'married_life') {
      initialText = this.state.married_life != undefined ? this.state.married_life : '';
    }
    if (info.identifier === 'contraceptive_remarks') {
      initialText = this.state.contraceptive_remarks != undefined ? this.state.contraceptive_remarks : '';
    }
    if (info.identifier === 'remarks') {
      initialText = this.state.remarks != undefined ? this.state.remarks : '';
    }
    if (info.identifier === 'pregnancy_risk_factor_management_remarks') {
      initialText = this.state.pregnancy_risk_factor_management_remarks != undefined ? this.state.pregnancy_risk_factor_management_remarks : '';
    }
    if (info.identifier === 'obstetric_remarks') {
      initialText = this.state.obstetric_remarks != undefined ? this.state.obstetric_remarks : '';
    }
    if (info.identifier === 'mother_remarks') {
      initialText = this.state.mother_remarks != undefined ? this.state.mother_remarks : '';
    }

    if (info.identifier === this.state.speech.identifier) {
      this.setState({
          speech: {
              identifier: info.identifier,
              state: !this.state.speech.state,
              initialText: initialText
          }
      }, () => {
          speechService.init(this.state.speech);
      });
    }
    else {
      this.setState({
        speech: {
          identifier: this.state.speech.identifier,
          state: false,
          initialText: ''
        }
      }, () => {
        speechService.init(this.state.speech);
        setTimeout(() => {
          this.setState({
            speech: {
              identifier: info.identifier,
              state: true,
              initialText: initialText
            }
          }, () => {
            speechService.init(this.state.speech);
          });
        }, 1000);
      });
    }
  }

	render() {
    const { ss_configuration, consult_type, sinceByList, contraceptives, confirmed_by, any_previous_complication_details, mother_fetal_parameters } = this.state;
    const textareaSizeDefault = { minRows: 3, maxRows: 6 };
		return (
      <Fragment>
        <MyHcSpeechRecognition />
				<div className="card-body  gynae_body p-1 emrfrm">
          <div className='container-fluid medicines  med-cont pb-2'>
            <Form
              layout='vertical'
              className='emrfrm'
              ref={this.obsGyaneFormRef}
            >
              {
                ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 21 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y') || (p?.id === 22 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    <div className='col-auto pr-3'>
                        <h6 className='text-primary mb-0'>Menstrual History</h6>
                    </div>
                    <div className='col-2'>
                      <div className='antInputItem hasdata'>
                        <Form.Item
                          label="Menarch Age"
                          name="menarch_age"
                          rules={[{
                            type: 'number',
                            min: 7,
                            max: this.state.patient_dob,
                            message:"Duration of period cannot be less than 7 or greater than patient age",
                            transform: function (value) {
                            return value === "" || value === undefined ? value : +value
                           }
                        }]}
                        >
                          <Input
                            addonAfter="Years"
                            maxLength="2"
                            name="menarch_age"
                            className="onlynumbers"
                            value={this.state.menarch_age}
                            disabled={!this.state.allowEdit}
                            onChange={this.handleOnNumberChange}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='col-2'>
                      <div className={`antInputItem hasdata`} style={{}}>
                        <Form.Item
                          label="Regularity"
                          name="regularity"

                        >
                          <Select
                            name="regularity"
                            onChange={(val, props) => this.onSelectChange(val, props, 'regularity')} 
                            value={this.state.regularity}
                            disabled={!this.state.allowEdit}
                          >
                            <Option value="regular">
                                Regular
                            </Option>
                            <Option value="irregular">
                                Irregular
                            </Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                :
                null
              }

              <div className='row d-flex align-items-center mb-4'>
                {
                  ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 22 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                  ?
                    <div className='col-2'>
                      <div className='antInputItem hasdata'>
                        <Form.Item
                          name="lmp"
                          className='mb-0'
                          label="LMP"
                        >
                          <DatePicker
                            name="lmp"
                            format="DD MMM, YYYY"
                            className='mb-0'
                            style={{
                                width: "100%",
                                height: "34px",
                            }}
                            allowClear={false}
                            onChange={(date, dateString) => this.handleLmpDateChange(date, dateString, 'lmp')}
                            disabledDate={this.disabledLmpDate}
                            disabled={!this.state.allowEdit}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  : 
                  null
                }
                <div className='col-2'>
                  <div className={`antInputItem hasdata`} style={{}}>
                    <Form.Item
                      name="bleeding_days"
                      label="Bleeding Days"
                      rules={[{
                          type: 'number',
                          min: 1,
                          max: 99,
                          message:"Duration of period cannot be less than 1 or greater than 99",
                          transform: function (value) {
                          return value === "" || value === undefined ? value : +value
                         }
                      }]}
                    >
                      <Input
                        type="text"
                        name="bleeding_days"
                        id="bleeding_days"
                        className="onlynumbers"
                        maxLength="2"
                        value={this.state.bleeding_days}
                        disabled={!this.state.allowEdit}
                        onChange={this.handleOnNumberChange}
                      />
                    </Form.Item>
                  </div>
                </div>
               { 
                  ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 21 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                  ? 
                    <div className='col-2'>
                      <div className='antInputItem hasdata'>
                        <Form.Item name={'cycle_length'} label={'Cycle Length (Days)'} rules={[{
                          type: 'number',
                          min: 10,
                          max: 99,
                          message: "Cycle length cannot be less than 10 or greater than 99.",
                          transform: function (value) {
                              return value === "" || value === undefined ? value : +value
                          }
                        }]} >
                          <Input
                              id={'cycle_length'}
                              name={'cycle_length'}
                              autoComplete="off"
                              maxlength="2"
                              value={this.state.cycle_length}
                              disabled={!this.state.allowEdit}
                              onChange={this.handleOnNumberChange}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  : 
                  null
                }
                <div className='col'>
                  <div className='antInputItem micwrap ant-mic-wrap hasdata'>
                    <Link
                      onClick={(e) => {
                          e.preventDefault(); this.initSpeech({ identifier: "menstrual_remarks" });
                      }}
                      className={
                        this.state.speech.identifier === "menstrual_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                      }
                    ></Link>
                    <Form.Item
                      label="Menstrual Remarks"
                      name="menstrual_remarks"
                    >
                       <TextArea
                        id="menstrual_remarks"
                        name="menstrual_remarks"
                        style={{ overflow: "hidden" }}
                        oninput="auto_height(this)"
                        onInput={(e) => this.autoHeight(e)}
                        placeholder='Menstrual Remarks'
                        autoComplete="off"
                        onChange={this.handleOnTextChange}
                        disabled={!this.state.allowEdit}
                        value={this.state.menstrual_remarks}
                      >
                      </TextArea>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className='row d-flex justify-content-between align-items-center'>
                <div className='col-10'>
                  <h6 className='text-primary mb-0'>Sexual History</h6>
                </div>
                <div className='col-auto'>
                  <Checkbox
                    name="sexual_history_data_confidential"
                    disabled={!this.state.allowEdit}
                    checked={this.state.sexual_history_data_confidential === '1'}
                    onChange={e => this.handleSexualDataConfidentialChange(e)}
                  >
                    <span className='text-secondary font-weight-bold'>Confidential</span>
                  </Checkbox>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-auto mr-3 pt-2">
                  <span className="pt-0 d-block font-cus">
                    Sexually Active 
                  </span>
                </div>
                <div className="col-auto pt-2">
                  <div className="custom-control custom-radio custom-control-inline mr-5">
                    <input
                      type="radio"
                      id="yes-sexually"
                      name="sexually_active"
                      className="custom-control-input"
                      disabled={!this.state.allowEdit}
                      value="1"
                      checked={this.state.sexually_active==='1'}
                      onChange={(e) => this.onChangeRadioCheck(e)}
                    />
                    <label
                      className="custom-control-label pl-2"
                      htmlFor="yes-sexually"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="no-sexually"
                      name="sexually_active"
                      className="custom-control-input"
                      disabled={!this.state.allowEdit}
                      value="0"
                      checked={this.state.sexually_active==='0'}
                      onChange={(e) => this.onChangeRadioCheck(e)}
                    />
                    <label
                      className="custom-control-label pl-2"
                      htmlFor="no-sexually"
                    >
                      No
                    </label>
                  </div>
                </div>
                <div className="col-auto">
                  <div className={this.state.since ? 'form-label-group input-group hasdata' : 'form-label-group input-group'} >
                    <input
                      type="text"
                      className="form-control onlynumbers"
                      id="since-sexual"
                      placeholder="Since"
                      maxLength="2"
                      name="since"
                      style={{ height: "calc(2rem + 2px)" }}
                      onChange={this.handleOnNumberChange}
                      disabled={!this.state.allowEdit}
                      value={this.state.since}
                    />
                    <span className="input-group-addon max-120" style={{ padding: "0px" }}>
                      <select className="custom-select" name="since_by" value={this.state.since_by} onChange={this.onSelectSinceByChange} disabled={!this.state.allowEdit}>
                          {sinceByList !== undefined && sinceByList.length > 0 ? sinceByList.map(d => (
                            <option key={d.id} value={d.id} label={d.desc}>{d.desc}</option>
                          )) : null}
                      </select>
                    </span>
                    <label
                      htmlFor="since-sexual"
                      className="pt-0"
                    >
                      Since
                    </label>
                  </div>
                </div>
                <div className='col'>
                  <div className={`antInputItem micwrap ant-mic-wrap hasdata`}>
                    <Link
                      onClick={(e) => {
                          e.preventDefault(); this.initSpeech({ identifier: "married_life" });
                      }}
                      className={
                        this.state.speech.identifier === "married_life" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                      }
                    ></Link>
                    <Form.Item
                      label="Married Life"
                      name="married_life"
                    >
                      <Input.TextArea
                        id="married_life"
                        name="married_life"
                        disabled={!this.state.allowEdit}
                        style={{ overflow: "hidden" }}
                        oninput="auto_height(this)"
                        onInput={(e) => this.autoHeight(e)}
                        onChange={this.handleOnTextChange}
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="row my-4">
                <div className="col-auto d-flex align-items-center pr-3">
                  Contraceptives
                </div>
                <div className='row d-flex align-items-center'>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="none"
                      checked={contraceptives?.includes('1')}
                      disabled={!this.state.allowEdit}
                      onChange={e => this.handleContraceptivesChange(e, '1')}  
                    >
                      None
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="condom"
                      checked={contraceptives?.includes('2')}
                      onChange={e => this.handleContraceptivesChange(e, '2')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      Condom
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="iud"
                      checked={contraceptives?.includes('3')}
                      disabled={!this.state.allowEdit}
                      onChange={e => this.handleContraceptivesChange(e, '3')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      IUD
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="ocp"
                      checked={contraceptives?.includes('4')}
                      disabled={!this.state.allowEdit}
                      onChange={e => this.handleContraceptivesChange(e, '4')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      OCP
                    </Checkbox>
                  </div>
                  <div className='col-auto pr-4'>
                    <Checkbox
                      name="hormonal"
                      checked={contraceptives?.includes('5')}
                      disabled={!this.state.allowEdit}
                      onChange={e => this.handleContraceptivesChange(e, '5')}
                      disabled={contraceptives?.includes('1') || !this.state.allowEdit}
                    >
                      Hormonal
                    </Checkbox>
                  </div>
                </div>
                <div className='col'>
                  <div className={this.state.contraceptive_remarks ? 'form-group micwrap ant-mic-wrap hasdata mb-0' : 'form-group micwrap ant-mic-wrap mb-0'}>
                    <Link
                      onClick={(e) => {
                          e.preventDefault(); this.initSpeech({ identifier: "contraceptive_remarks" });
                      }}
                      className={
                        this.state.speech.identifier === "contraceptive_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                      }
                    ></Link>
                    <Input.TextArea
                      className="form-control speech-field"
                      rows="1"
                      placeholder="Contraceptive Remarks"
                      disabled={!this.state.allowEdit}
                      id="contraceptive_remarks"
                      // maxlegth="255"
                      oninput="auto_height(this)"
                      onInput={(e) => this.autoHeight(e)}
                      name="contraceptive_remarks"
                      onChange={this.handleOnTextChange}
                      value={this.state.contraceptive_remarks}
                    />
                    <label htmlFor="contraceptive_remarks">
                        Contraceptive Remarks
                    </label>
                  </div>
                </div>
              </div>
              {
                ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 34 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <div className='row d-flex align-items-center'>
                    <div className='col'>
                      <div className={`form-group antInputItem micwrap ant-mic-wrap hasdata`}>
                        <Link
                          onClick={(e) => {
                              e.preventDefault(); this.initSpeech({ identifier: "remarks" });
                          }}
                          className={
                            this.state.speech.identifier === "remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                          }
                        ></Link>
                        <Input.TextArea
                          className="form-control diagnosis_notes_class speech-field"
                          id="remarks"
                          name="remarks"
                          oninput="auto_height(this)"
                          onInput={(e) => this.autoHeight(e)}
                          disabled={!this.state.allowEdit}
                          onChange={this.handleOnTextChange}
                          value={this.state.remarks}
                        />
                        <label htmlFor="remarks">Remarks </label>
                      </div>
                    </div>
                    <div className='col-auto mb-4 text-right '>
                      <Checkbox
                        name="remarks_confidential"
                        checked={this.state.remarks_confidential === '1'}
                        disabled={!this.state.allowEdit}
                        onChange={e => this.handleSexualRemarksConfidentialChange(e)}
                      >
                        <span className='text-secondary font-weight-bold'>Confidential</span>
                      </Checkbox>
                    </div>
                  </div>
                :
                null
              }
              {
                ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 25 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y') || (p?.id === 26 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    {
                      ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 26 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y') || (p?.id === 26 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                      ?
                        <>
                          <div className='col-auto d-flex align-items-center'>
                            <div className='antInputItem hasdata'>
                              <label className="d-md-inline mr-3 mb-0">Pregnant</label>
                              <div className="mr-2 d-md-inline">
                                <Form.Item
                                  name="pregnant"
                                  className='mb-0'
                                  >
                                  <Radio.Group name='pregnant' defaultValue={this.state.pregnant} onChange={(e) => this.onChangePregnantCheck(e)} disabled={!this.state.allowEdit}>
                                    <Radio value="0" name="no">No</Radio>
                                    <Radio value="1" name="yes">Yes</Radio>
                                  </Radio.Group>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className='col-auto'>
                            <div className='antInputItem hasdata'>
                              <Form.Item
                                name="edd_by_lmp"
                                className='mb-0'
                                label="EDD By LMP"
                                style={{ display: this.state.pregnant === "0" ? 'none' : 'block' }}
                              >
                                <DatePicker
                                  name="edd_by_lmp"
                                  format="DD MMM, YYYY"
                                  className='mb-0'
                                  style={{
                                      width: "100%",
                                      height: "34px",
                                  }}
                                  allowClear={false}
                                  defaultValue={this.state.edd_by_lmp}
                                  disabled={!this.state.allowEdit}
                                  value={this.state.edd_by_lmp}
                                  onChange={(date, dateString) => this.handleEDDChange(date, dateString, 'edd_by_lmp')}
                                  disabledDate={this.disableEDDDate}
                                />
                              </Form.Item>
                            </div>
                          </div>
                          <div className='col-2 order-xl-1 order-2  pt-md-2 pt-xl-0'>
                            <div className='antInputItem hasdata'>
                              <Form.Item
                                name="corrected_edd"
                                className='mb-0'
                                label="Corrected EDD"
                                style={{ display: this.state.pregnant === "0" ? 'none' : 'block' }}
                              >
                                <DatePicker
                                  name="corrected_edd"
                                  format="DD MMM, YYYY"
                                  className='mb-0'
                                  style={{
                                      width: "100%",
                                      height: "34px",
                                  }}
                                  allowClear={false}
                                  defaultValue={this.state.corrected_edd}
                                  disabled={!this.state.allowEdit}
                                  value={this.state.corrected_edd}
                                  defaultPickerValue={this.navigateCorrectedEddDate}
                                  onChange={(date, dateString) => this.handleCorrectedEDDChange(date, dateString, 'corrected_edd')}
                                  disabledDate={this.disableCorrectedEDDDate}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </>
                      :
                      null
                    }
                    {
                      ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 25 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                      ?
                        <div className='col order-xl-2 order-1 text-right'>
                          <Checkbox
                            name="lactating"
                            checked={this.state.lactating === '1'}
                            onChange={e => this.handleLactatingChange(e)}
                            disabled={!this.state.allowEdit}
                          >
                            Lactating
                          </Checkbox>
                        </div>
                      :
                      null
                    }
                  </div>
                : 
                null
              }
              {
                (this.state.pregnant == "1" && (ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 26 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))))
                ?
                  <div className='row d-flex align-items-center'>
                    <div className='col-auto pr-4'>
                      <h6 className='text-primary mb-0 pt-1'>Confirmed by</h6>
                    </div>
                    <div className='col-auto pr-3'>
                        <Checkbox
                          name="upt"
                          checked={confirmed_by?.includes('1')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '1')}   
                        >
                          UPT
                        </Checkbox>
                    </div>
                    <div className='col-auto pr-3'>
                        <Checkbox
                          name="serumhcg"
                          checked={confirmed_by?.includes('2')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '2')}   
                        >
                          Serum HCG
                        </Checkbox>
                    </div>
                    <div className='col-auto pr-3'>
                        <Checkbox
                          name="usg"
                          checked={confirmed_by?.includes('3')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '3')}   
                        >
                          USG
                        </Checkbox>
                    </div>
                    <div className='col-auto'>
                        <Checkbox
                          name="home"
                          checked={confirmed_by?.includes('4')}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleConfirmedByChange(e, '4')}   
                        >
                          Home Pregnancy Test
                        </Checkbox>
                    </div>
                  </div>
                :
                null
              }
              {
                ((ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 26 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))) ) || ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 30 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    {
                      (this.state.pregnant == "1" && (ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 26 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y'))))))) 
                      ?
                        <div className='col-6'>
                          <div className='row d-flex align-items-center'>
                            <div className='col-12'>
                              <h6 className='text-primary' >Gestational Age</h6>
                            </div>
                          </div>
                          <div className='row mt-3'>
                              <div className='col-auto' >
                                <label>By LMP</label>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Weeks"
                                    name="gestational_age_by_lmp_weeks"
                                  >
                                    <Input
                                      id="weeks"
                                      name="gestational_age_by_lmp_weeks"
                                      disabled={!this.state.allowEdit}
                                      maxlength="2"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_lmp_weeks}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Days"
                                    name="gestational_age_by_lmp_days"
                                    disabled={!this.state.allowEdit}
                                    rules={[
                                      { pattern: /^(0?)([1-6]{0,1})$/, message: 'Not allowed!' }
                                    ]}
                                  >
                                    <Input
                                      id="days"
                                      name="gestational_age_by_lmp_days"
                                      disabled={!this.state.allowEdit}
                                      maxlength="1"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_lmp_days}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='col-auto pl-4' >
                                <label>By USG</label>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Weeks"
                                    name="gestational_age_by_usg_weeks"
                                  >
                                    <Input
                                      id="weeks"
                                      name="gestational_age_by_usg_weeks"
                                      disabled={!this.state.allowEdit}
                                      maxLength="2"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_usg_weeks}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='col-2'>
                                <div className='antInputItem hasdata'>
                                  <Form.Item
                                    label="Days"
                                    name="gestational_age_by_usg_days"
                                    rules={[
                                      { pattern: /^(0?)([1-6]{0,1})$/, message: 'Not allowed!' }
                                      ]}
                                  >
                                    <Input
                                      id="days"
                                      name="gestational_age_by_usg_days"
                                      disabled={!this.state.allowEdit}
                                      maxLength="1"
                                      onChange={this.handleOnNumberChange}
                                      value={this.state.gestational_age_by_usg_days}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                          </div>
                        </div>
                      :
                      null
                    }

                    {
                      ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 30 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                      ?
                        <div className="col-6">
                          <div className='row '>
                            <div className='col-4'>
                              <h6 className='text-primary mb-0'>Obstetric History</h6>
                            </div>
                            <div className='col-4 text-center'>
                              {
                                this.state.prevAncCardData?.length > 0 
                                ?
                                  <a className='text-secondary font-weight-bold'  onClick={() => { this.setState({ previousPregnancyDetailsModal: true }) }}>
                                    <u>Previous Pregnancy Details</u>
                                  </a>
                                :
                                null
                              }
                            </div> 
                            <div className='col-4 text-right'>
                              <Checkbox
                                name="obstetric_data_confidential"
                                disabled={!this.state.allowEdit}
                                checked={this.state.obstetric_data_confidential === '1'}
                                onChange={e => this.handleObsterticDataConfidentialChange(e)}
                              >
                                <span className='text-secondary font-weight-bold'>Confidential</span>
                              </Checkbox>
                            </div>
                          </div>
                          <div className='row mt-2'>
                            <div className="col-12">
                              <div className='card obs-hiscard mb-0'>
                                <div className='row'>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                        <Form.Item
                                          label="Gravidity"
                                          name="gravidity"
                                          rules={[
                                            {
                                                // pattern: /^\d{1,2}$/, message: 'Not allowed!'
                                              validator: (_, value) => {
                                                const parsedValue = parseInt(value);
                                                if (!/^\d{1,2}$/.test(value)) {
                                                  return Promise.reject(new Error('Must be a 1 or 2-digit number'));
                                                }

                                                const form = this.obsGyaneFormRef.current;
                                                const parity = parseInt(form.getFieldValue('parity')) || 0;
                                                const abortion = parseInt(form.getFieldValue('abortion')) || 0;
                                                const ectopic = parseInt(form.getFieldValue('ectopic')) || 0;
                                                const mtp = parseInt(form.getFieldValue('mtp')) || 0;
                                                const miscarriage = parseInt(form.getFieldValue('miscarriage')) || 0;

                                                const maxValue = Math.max(parity, abortion, ectopic, mtp, miscarriage);
                                                if (parsedValue < maxValue) {
                                                  return Promise.reject(
                                                    new Error('Gravidity should be equal to or greater than all other pregnancy-related values')
                                                  );
                                                }
                                                return Promise.resolve();
                                              }
                                            },
                                          ]}
                                        >
                                          <Input
                                            id="gravidity"
                                            name="gravidity"
                                            disabled={!this.state.allowEdit}
                                            // type="text"
                                            maxLength="2"
                                            onChange={this.handleOnNumberChange}
                                            value={this.state.gravidity}
                                          />
                                        </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Parity"
                                        name="parity"
                                        rules={[
                                            { pattern: /^\d{1,2}$/, message: 'Not allowed!' },
                                        ]}
                                      >
                                        <Input
                                          id="parity"
                                          name="parity"
                                          disabled={!this.state.allowEdit}
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          value={this.state.parity}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-4'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Abortion"
                                        name="abortion"
                                        rules={[
                                            { pattern: /^\d{1,2}$/, message: 'Not allowed!' },
                                        ]}
                                      >
                                        <Input
                                          id="abortion"
                                          name="abortion"
                                          disabled={!this.state.allowEdit}
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          value={this.state.abortion}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Live Birth"
                                        name="live_birth"
                                        rules={[
                                          { 
                                              // pattern: /^\d{1,2}$/, message: 'Not allowed!'
                                            validator: (_, value) => {
                                              const g = parseInt(this.obsGyaneFormRef.current.getFieldValue('gravidity'));
                                              const p = parseInt(this.obsGyaneFormRef.current.getFieldValue('parity'));
                                              const l = parseInt(value);
                                              // if (value === undefined || value === "") {
                                              //     return Promise.reject(new Error('Please enter a value for Live Birth'));
                                              // }
                                              if (!/^\d{1,2}$/.test(value)) {
                                                  return Promise.reject(new Error('The value must be a 1 or 2-digit number'));
                                              }
                                              if ((g && l > g) || (p && l > p)) {
                                                  return Promise.reject(new Error('Live Birth cannot be more than Gravidity or Parity'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="live_birth"
                                          name="live_birth"
                                          disabled={!this.state.allowEdit}
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          value={this.state.live_birth}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Ectopic"
                                        name="ectopic"
                                        rules={[
                                            { pattern: /^\d{1,2}$/, message: 'Not allowed!' },
                                        ]}
                                      >
                                        <Input
                                          id="ectopic"
                                          name="ectopic"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.ectopic}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                </div>
                                <div className='row mt-3'>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="LSCS"
                                        name="lscs"
                                        rules={[
                                          {
                                                // pattern: /^\d{1,2}$/, message: 'Not allowed!'
                                            validator: (_, value) => {
                                              const g = parseInt(this.obsGyaneFormRef.current.getFieldValue('gravidity'));
                                              const p = parseInt(this.obsGyaneFormRef.current.getFieldValue('parity'));
                                              const live = parseInt(this.obsGyaneFormRef.current.getFieldValue('live_birth'));
                                              const preterm = parseInt(this.obsGyaneFormRef.current.getFieldValue('preterm'));
                                              const lscs = parseInt(value);

                                              if (value === undefined || value === "") {
                                                  return Promise.resolve();
                                              }

                                              if (!/^\d$/.test(value)) {
                                                  return Promise.reject(new Error('Must be a single-digit number (0–9)'));
                                              }

                                              if ((g && lscs > g) || (p && lscs > p)) {
                                                  return Promise.reject(new Error('LSCS must not exceed Gravidity or Parity'));
                                              }

                                              if (live !== lscs && preterm !== lscs) {
                                                  return Promise.reject(new Error('LSCS must equal Live Births or Pre-Term births'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="lscs"
                                          name="lscs"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.lscs}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Miscarriage"
                                        name="miscarriage"
                                        rules={[
                                          {
                                            // pattern: /^\d{1,2}$/, message: 'Not allowed!'
                                            validator: (_, value) => {
                                                const g = parseInt(this.obsGyaneFormRef.current.getFieldValue('gravidity'));
                                                const p = parseInt(this.obsGyaneFormRef.current.getFieldValue('parity'));
                                                const preterm = parseInt(this.obsGyaneFormRef.current.getFieldValue('preterm'));
                                                const miscarriage = parseInt(value);

                                                if (value === undefined || value === "") {
                                                    return Promise.resolve();
                                                }

                                                if (!/^\d$/.test(value)) {
                                                    return Promise.reject(new Error('Must be a single-digit number (0–9)'));
                                                }

                                                if ((g && miscarriage > g) || (p && miscarriage > p)) {
                                                    return Promise.reject(new Error('Miscarriage cannot be more than Gravidity or Parity'));
                                                }

                                                if (preterm !== miscarriage) {
                                                    return Promise.reject(new Error('Miscarriage must equal Pre-Term births'));
                                                }

                                                return Promise.resolve();
                                              }
                                            },
                                          ]}
                                        >
                                          <Input
                                            id="miscarriage"
                                            name="miscarriage"
                                            // type="text"
                                            maxLength="2"
                                            onChange={this.handleOnNumberChange}
                                            disabled={!this.state.allowEdit}
                                            value={this.state.miscarriage}
                                          />
                                        </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="MTP"
                                        name="mtp"
                                        rules={[
                                          {
                                            // pattern: /^\d{1,2}$/, message: 'Not allowed!'
                                            validator: (_, value) => {
                                              const g = parseInt(this.obsGyaneFormRef.current.getFieldValue('gravidity'));
                                              const p = parseInt(this.obsGyaneFormRef.current.getFieldValue('parity'));
                                              const abortion = parseInt(this.obsGyaneFormRef.current.getFieldValue('abortion'));
                                              const preterm = parseInt(this.obsGyaneFormRef.current.getFieldValue('preterm'));
                                              const mtp = parseInt(value);

                                              if (value === undefined || value === "") {
                                                  return Promise.resolve();
                                              }

                                              if (!/^\d$/.test(value)) {
                                                  return Promise.reject(new Error('Must be a single-digit number (0–9)'));
                                              }

                                              if ((g && mtp > g) || (p && mtp > p)) {
                                                  return Promise.reject(new Error('MTP cannot be more than Gravidity or Parity'));
                                              }

                                              if (abortion !== mtp && preterm !== mtp) {
                                                  return Promise.reject(new Error('MTP must match Abortion or Pre-Term'));
                                              }
                                              return Promise.resolve();
                                            }
                                          },
                                        ]}
                                      >
                                        <Input
                                          id="mtp"
                                          name="mtp"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.mtp}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Preterm"
                                        name="preterm"
                                        rules={[
                                          {
                                            // pattern: /^\d{1,2}$/, message: 'Not allowed!'
                                            validator: (_, value) => {
                                              const g = parseInt(this.obsGyaneFormRef.current.getFieldValue('gravidity'));
                                              const p = parseInt(this.obsGyaneFormRef.current.getFieldValue('parity'));
                                              const preterm = parseInt(value);

                                              if (value === undefined || value === "") {
                                                  return Promise.resolve();
                                              }

                                              if (!/^\d$/.test(value)) {
                                                  return Promise.reject(new Error('Must be a single-digit number (0–9)'));
                                              }

                                              if ((g && preterm > g) || (p && preterm > p)) {
                                                  return Promise.reject(new Error('Preterm cannot exceed Gravidity or Parity'));
                                              }

                                              return Promise.resolve();
                                            }

                                          },
                                        ]}
                                      >
                                        <Input
                                          id="preterm"
                                          name="preterm"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.preterm}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Term"
                                        name="term"
                                        rules={[
                                          {
                                              // pattern: /^\d{1,2}$/, message: 'Not allowed!'
                                            validator: (_, value) => {
                                              const g = parseInt(this.obsGyaneFormRef.current.getFieldValue('gravidity'));
                                              const p = parseInt(this.obsGyaneFormRef.current.getFieldValue('parity'));
                                              const term = parseInt(value);

                                              if (value === undefined || value === "") {
                                                  return Promise.resolve();
                                              }

                                              // if (!/^\d$/.test(value)) {
                                              //     return Promise.reject(new Error('Must be a single-digit number (0–9)'));
                                              // }

                                              if ((g && term > g) || (p && term > p)) {
                                                  return Promise.reject(new Error('Term cannot exceed Gravidity or Parity'));
                                              }

                                              return Promise.resolve();
                                            }

                                          },
                                        ]}
                                      >
                                        <Input
                                          id="term"
                                          name="term"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.term}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className='col-2'>
                                    <div className='antInputItem hasdata'>
                                      <Form.Item
                                        label="Still Birth"
                                        name="still_birth"
                                        rules={[
                                          {
                                            // pattern: /^\d{1,2}$/, message: 'Not allowed!' 
                                            validator: (_, value) => {
                                              const g = parseInt(this.obsGyaneFormRef.current.getFieldValue('gravidity'));
                                              const p = parseInt(this.obsGyaneFormRef.current.getFieldValue('parity'));
                                              const pt = parseInt(this.obsGyaneFormRef.current.getFieldValue('preterm'));
                                              const sb = parseInt(value);

                                              // if (value === undefined || value === "") {
                                              //     return Promise.reject(new Error('Please enter a value for Still Birth'));
                                              // }

                                              if (!/^\d$/.test(value)) {
                                                  return Promise.reject(new Error('The value must be a single-digit number (0–9)'));
                                              }

                                              if ((g && sb > g) || (p && sb > p)) {
                                                  return Promise.reject(new Error('This cannot be more than Gravidity or Parity'));
                                              }

                                              return Promise.resolve();
                                            }

                                          },
                                        ]}
                                      >
                                        <Input
                                          id="still_birth"
                                          name="still_birth"
                                          // type="text"
                                          maxLength="2"
                                          onChange={this.handleOnNumberChange}
                                          disabled={!this.state.allowEdit}
                                          value={this.state.still_birth}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      :
                      null
                    }
                  </div>
                :
                null
              }
              {
                ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 28 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    <div className='col-12'>
                      <div className="antSelectItem hasdata">
                        <Form.Item
                          label="Pregnancy risk factors"
                          name="pregnancy_risk_factor"
                        >
                          <Select
                            showSearch
                            mode="multiple"
                            value={this.state.pregnancy_risk_factor_selected}
                            notFoundContent={null}
                            filterOption={true}
                            disabled={!this.state.allowEdit}
                            onChange={this.handleOnPregnancyRiskFactorChange}
                            style={{ width: '100%' }}
                            optionFilterProp="children"
                          >
                            {this.optionRiskFactorsLoad()}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                :
                null
              }
              {
                ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 29 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    <div className='col-12'>
                      <div className={`form-group antInputItem micwrap hasdata`}>
                        <Link
                          onClick={(e) => {
                              e.preventDefault(); this.initSpeech({ identifier: "pregnancy_risk_factor_management_remarks" });
                          }}
                          className={
                            this.state.speech.identifier === "pregnancy_risk_factor_management_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                          }
                        ></Link>
                        <Form.Item
                          label="Pregnancy Risk Factor Management Remarks"
                          name="pregnancy_risk_factor_management_remarks"
                        >
                        <Input.TextArea
                          className="form-control diagnosis_notes_class speech-field"
                          id="pregnancy_risk_factor_management_remarks"
                          name="pregnancy_risk_factor_management_remarks"
                          placeholder="Enter"
                          autoSize={{ minRows: 1.3, maxRows: 6 }}
                          maxLength={255}
                          disabled={!this.state.allowEdit}
                          onInput={(e) => this.autoHeight(e)}
                          onChange={this.handleOnTextChange}
                          value={this.state.pregnancy_risk_factor_management_remarks}
                        />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                :
                null
              }
              {
                ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 32 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <>
                    <div className="row d-flex align-items-center mb-4">
                      <div className='col-auto d-flex align-items-center'>
                        <h6 className='text-primary mb-0 pr-3'>Any Previous Complication</h6>
                        <div className="mr-2 d-md-inline">
                          <Form.Item
                            name="any_previous_complications"
                            className='mb-0'
                          >
                            <Radio.Group name='any_previous_complications' defaultValue={this.state.any_previous_complications} onChange={(e) => this.onChangePreviousComplicationCheck(e)} disabled={!this.state.allowEdit}>
                              <Radio value="0" name="no">No</Radio>
                              <Radio value="1" name="yes">Yes</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <div className='row align-items-center mb-4' style={{ display: this.state.any_previous_complications === "1" ? 'block' : 'none' }}>
                      <div className='col-12'>
                        <div className='row'>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="aph"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('1')}
                              onChange={e => this.handleComplicationDetailsChange(e, '1')}
                            >
                              APH
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="ec"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('2')}
                              onChange={e => this.handleComplicationDetailsChange(e, '2')}
                            >
                              Eclampsia
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="pih"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('3')}
                              onChange={e => this.handleComplicationDetailsChange(e, '3')}
                            >
                              PIH
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="pph"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('4')}
                              onChange={e => this.handleComplicationDetailsChange(e, '4')}
                            >
                              PPH
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="anemia"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('5')}
                              onChange={e => this.handleComplicationDetailsChange(e, '5')}
                            >
                              Anaemia
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="obslab"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('6')}
                              onChange={e => this.handleComplicationDetailsChange(e, '6')}
                            >
                              Obstructed Labor
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="lscs"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('7')}
                              onChange={e => this.handleComplicationDetailsChange(e, '7')}
                            >
                              LSCS
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="congano"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('8')}
                              onChange={e => this.handleComplicationDetailsChange(e, '8')}
                            >
                              Congenital Anamoly
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="abort"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('9')}
                              onChange={e => this.handleComplicationDetailsChange(e, '9')}
                            >
                              Abortion
                            </Checkbox>
                          </div>
                          <div className='col-auto pr-4 pb-2'>
                            <Checkbox
                              name="anyother"
                              disabled={!this.state.allowEdit}
                              checked={any_previous_complication_details?.includes('10')}
                              onChange={e => this.handleComplicationDetailsChange(e, '10')}
                            >
                              Any Other
                            </Checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                :
                null
              }
              {
                ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 33 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y')))))
                ?
                  <div className='row d-flex align-items-center mb-4'>
                    <div className='col-12'>
                      <div className={`form-group antInputItem micwrap hasdata`}>
                        <Link
                          onClick={(e) => {
                              e.preventDefault(); this.initSpeech({ identifier: "obstetric_remarks" });
                          }}
                          className={
                            this.state.speech.identifier === "obstetric_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                          }
                        ></Link>
                        <Input.TextArea
                          className="form-control diagnosis_notes_class speech-field"
                          id="obstetric_remarks"
                          name="obstetric_remarks"
                          autoSize={textareaSizeDefault}
                          disabled={!this.state.allowEdit}
                          // maxLength={255}
                          oninput="auto_height(this)"
                          onInput={(e) => this.autoHeight(e)}
                          onChange={this.handleOnTextChange}
                          value={this.state.obstetric_remarks}
                        />
                        <label htmlFor="obstetric_remarks">Obstetric Remarks </label>
                      </div>
                    </div>
                  </div>
                :
                null
              }
              {
                (this.state.pregnant == "1" && (ss_configuration && ss_configuration?.some(o => (o?.id === 16 && o?.sub_items?.some(p => ((p?.id === 26 && p?.configuration?.[consult_type + '_screen']?.selected == 'Y'))))))) 
                ?
                  <>
                    <div className='row d-flex align-items-center mb-4'>
                      <div className='col-auto d-flex align-items-center'>
                        <h6 className='text-primary mb-0 pr-3'>Mother & Fetal Parameters</h6>
                      </div>
                      <div className='col-2'>
                        <div className='antInputItem hasdata'>
                          <Form.Item
                            label="No. of Fetus"
                            name="no_of_fetus"
                            rules={[
                                { required: true, message: 'Please fill No. Of Fetus.' },
                                { pattern: /^[1-9]{1,1}$/, message: 'Not allowed!' },
                                /* {max: 8, message: 'Max 8 chars.'} */
                            ]}
                          >
                            <Input
                              id="no_of_fetus"
                              name="no_of_fetus"
                              disabled={!this.state.allowEdit}
                              onChange={(e) => this.handleFetusChange(e.target.value)}
                              className="onlynumbers"
                              value={this.state.no_of_fetus}
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className='col text-right '>
                        <Checkbox
                          name="mother_fetal_print_with_prescription"
                          checked={this.state.mother_fetal_print_with_prescription === '1'}
                          disabled={!this.state.allowEdit}
                          onChange={e => this.handleMotherFetalPrintWithPrescription(e)}
                        >
                          <span className='text-secondary font-weight-bold'>Print with Prescription</span>
                        </Checkbox>
                      </div>
                    </div>
                    <div className='row d-flex align-items-center mb-4'>
                      <div className='col-12'>
                        <div className='card lightblue-card mb-0'>
                          <div className='row'>
                            <div className='col-7'>
                              <div className='row'>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>POG (Weeks)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_pog"
                                    >
                                      <Input
                                        id="mother_pog"
                                        name="mother_pog"
                                        onChange={this.handleOnTextChange}
                                        disabled={!this.state.allowEdit}
                                        value={this.state.mother_pog}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Weight (Kg)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_weight"
                                    >
                                      <Input
                                        id="mother_weight"
                                        name="mother_weight"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_weight}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>BP (mmHg)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                        label=""
                                        name="mother_blood_pressure"
                                    >
                                      <Input
                                        id="mother_blood_pressure"
                                        name="mother_blood_pressure"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_blood_pressure}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='col-5'>
                              <div className='row'>
                                <div className='col-6'>
                                  <h6 className='text-primary mb-1'>Pulse Rate (min)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_pulse_rate"
                                    >
                                      <Input
                                        id="mother_pulse_rate"
                                        name="mother_pulse_rate"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_pulse_rate}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-6'>
                                  <h6 className='text-primary mb-1'>Fundal Ht (cm)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                        label=""
                                        name="mother_fundal_height"
                                    >
                                      <Input
                                        id="mother_fundal_height"
                                        name="mother_fundal_height"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_fundal_height}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row mt-3'>
                            <div className='col-7'>
                              <div className='row'>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Edema</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_edema"
                                    >
                                      <Input
                                        id="mother_edema"
                                        name="mother_edema"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_edema} 
                                        />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Pallor</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_pallor"
                                    >
                                      <Input
                                        id="mother_pallor"
                                        name="mother_pallor"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_pallor}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                                <div className='col-4'>
                                  <h6 className='text-primary mb-1'>Cervix Exam</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_cervix_exam"
                                    >
                                      <Input
                                        name="mother_cervix_exam"
                                        id="mother_cervix_exam"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_cervix_exam}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='col-5'>
                              <div className='row'>
                                <div className='col-xl-6 col-8'>
                                  <h6 className='text-primary mb-1'>Preterm Labour (Sign/Symptoms)</h6>
                                  <div className='antInputItem hasdata'>
                                    <Form.Item
                                      label=""
                                      name="mother_preterm_labour"
                                    >
                                      <Input
                                        id="mother_preterm_labour"
                                        name="mother_preterm_labour"
                                        disabled={!this.state.allowEdit}
                                        onChange={this.handleOnTextChange}
                                        value={this.state.mother_preterm_labour}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-12'>
                        <div className='card blue-card mb-0'>
                          <Form.List name="blood_bag_master">
                            {() => (
                              mother_fetal_parameters.map((item, key) => (
                                <>
                                  <div className="row mb-4">
                                    <div className="col-1 pt-1">
                                      F{key + 1}
                                    </div>
                                    <div className="col-3">
                                      <div className={'antSelectItem hasdata'}>
                                        <Form.Item
                                          label="Fetal Movement"
                                          preserve={false}
                                        >
                                          <Select
                                            showSearch
                                            style={{ width: '100%' }}
                                            optionFilterProp="children"
                                            value={item.fetal_movement}
                                            disabled={!this.state.allowEdit}
                                            onChange={(val, props) => this.handleFetalParamsSelectChange(val, props, 'fetal_movement', key)}
                                          >
                                            {FETAL_MOVEMENT !== undefined ? Object.keys(FETAL_MOVEMENT).map((d, i) => (
                                                <Option key={i} value={d} label={FETAL_MOVEMENT[d]}>
                                                    {FETAL_MOVEMENT[d]}
                                                </Option>
                                            )) : null}
                                          </Select>
                                          </Form.Item>
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      <div className={'antInputItem hasdata'}>
                                        <Form.Item
                                          label="Fetal Heart Rate (b/min)"
                                          preserve={false}
                                        >
                                          <Input
                                            autoComplete="off"
                                            type="text"
                                            maxLength="3"
                                            name="fetal_heart_rate"
                                            disabled={!this.state.allowEdit}
                                            onChange={(e) => this.handleFetalParamsChange(e, 'fetal_heart_rate', key)}
                                            defaultValue={item.fetal_heart_rate}
                                          />
                                        </Form.Item>
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      <div className={'antSelectItem hasdata'}>
                                        <Form.Item
                                          label="Presentation"
                                          preserve={false}
                                        >
                                          <Select
                                            showSearch
                                            style={{ width: '100%' }}
                                            optionFilterProp="children"
                                            value={item.presentation}
                                            disabled={!this.state.allowEdit}
                                            onChange={(val, props) => this.handleFetalParamsSelectChange(val, props, 'presentation', key)}
                                          >
                                            {PRESENTATION !== undefined ? Object.keys(PRESENTATION).map((d, i) => (
                                                <Option key={i} value={d} label={PRESENTATION[d]}>
                                                    {PRESENTATION[d]}
                                                </Option>
                                            )) : null}
                                          </Select>
                                        </Form.Item>
                                      </div>
                                    </div>
                                    <div className="col-2">
                                      <div className={'antSelectItem hasdata'}>
                                        <Form.Item
                                          label="Relation of PP to Brim"
                                          preserve={false}
                                        >
                                          <Select showSearch style={{ width: '100%' }}
                                            value={item.relationship_of_pp_to_brim}
                                            disabled={!this.state.allowEdit}
                                            onChange={(val, props) => this.handleFetalParamsSelectChange(val, props, 'relationship_of_pp_to_brim', key)}
                                          >
                                            {RELATIONSHIP_TO_PP_BRIM !== undefined ? Object.keys(RELATIONSHIP_TO_PP_BRIM).map((d, i) => (
                                                <Option key={i} value={d} label={RELATIONSHIP_TO_PP_BRIM[d]}>
                                                    {RELATIONSHIP_TO_PP_BRIM[d]}
                                                </Option>
                                            )) : null}
                                          </Select>
                                        </Form.Item>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-4">
                                    <div className="col-1 pt-1">
                                        &nbsp;
                                    </div>
                                    <div className="col-3">
                                        <div className={'antInputItem hasdata'}>
                                          <Form.Item
                                                label="Head CC (cm)"
                                                preserve={false}
                                            >
                                            <Input
                                                type="text"
                                                autoComplete="off"
                                                maxLength="4"
                                                name="head_cc"
                                                disabled={!this.state.allowEdit}
                                                defaultValue={item.head_cc}
                                                onChange={(e) => this.handleFetalParamsChange(e, 'head_cc', key)}
                                            />
                                          </Form.Item>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className={'antInputItem hasdata'}>
                                          <Form.Item
                                              label="Abdominal CC (cm)"
                                              preserve={false}
                                          >
                                            <Input
                                                type="text"
                                                autoComplete="off"
                                                placeholder="Abdominal CC (cm)"
                                                maxLength="4"
                                                name="abdominal_cc"
                                                disabled={!this.state.allowEdit}
                                                defaultValue={item.abdominal_cc}
                                                onChange={(e) => this.handleFetalParamsChange(e, 'abdominal_cc', key)}
                                            />
                                          </Form.Item>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className={'antInputItem hasdata'}>
                                          <Form.Item
                                              label="Femur Length (cm)"
                                              preserve={false}
                                          >
                                            <Input
                                                type="text"
                                                autoComplete="off"
                                                placeholder="Femur Length (cm)"
                                                maxLength="4"
                                                name="femur_length"
                                                disabled={!this.state.allowEdit}
                                                defaultValue={item.femur_length}
                                                onChange={(e) => this.handleFetalParamsChange(e, 'femur_length', key)}

                                            />
                                          </Form.Item>
                                        </div>
                                    </div>
                                  </div>
                                </>
                              ))
                            )}
                          </Form.List>
                          <div className='row'>
                            <div className="col-12">
                              <div className={`form-group antInputItem micwrap ant-mic-wrap hasdata`}>
                                <Link
                                  onClick={(e) => {
                                      e.preventDefault(); this.initSpeech({ identifier: "mother_remarks" });
                                  }}
                                  className={
                                    this.state.speech.identifier === "mother_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                                  }
                                ></Link>
                                <Input.TextArea
                                  className="form-control diagnosis_notes_class speech-field"
                                  id="m_remarks"
                                  name="mother_remarks"
                                  autoSize={textareaSizeDefault}
                                  oninput="auto_height(this)"
                                  onInput={(e) => this.autoHeight(e)}
                                  onChange={this.handleOnTextChange}
                                  disabled={!this.state.allowEdit}
                                  value={this.state.mother_remarks}
                                />
                                <label htmlFor="mother_remarks">Remarks </label>
                              </div>
                            </div>
                          </div>                        
                        </div>
                      </div>
                    </div>
                  </>
                :
                null
              }
            </Form>
          </div>
        </div>

        <Modal
          id="alert_confirm_message"
          className="alert_confirm_message"
          visible={this.state.prevRecordedObsGynaePopupVisible}
          bodyStyle={{ padding: "25px 10px" }}
          closable={false}
          width="400px"
          footer={[
              <div className="text-center">
                <button
                  className="btn btn-outline-secondary px-5 cancelOrderSet"
                  onClick={(e) => this.copyPrevRecordedObsGynae(e, 'N')}
                >
                  NO
                </button>
                <button
                  className="btn btn-primary px-5 deleteOrderSet ml-1"
                  id='deleteButton'
                  onClick={(e) => this.copyPrevRecordedObsGynae(e, 'Y')}
                >
                  YES
                </button>
              </div>,
            ]}
          >
            <div className="container-fluid emrfrm">
                <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        The patient was marked pregnant during previous visit. Do you want to copy the pregnancy details from visit date {moment(this.state.obsGynaePrevData?.created_at).format("DD MMM, YYYY")}?
                      </div>
                    </div>
                </div>
            </div>
          </Modal>

          <Modal
            id="prev_pregnency_details"
            className="prev_pregnency_details"
            visible={this.state.previousPregnancyDetailsModal}
            bodyStyle={{ padding: "25px 10px" }}
            closable={false}
            width="1000px"
            footer={[
              <div className="text-center">
                <button
                  className="btn btn-outline-secondary px-5 cancelOrderSet"
                  onClick={(e) => this.closePopup(e, 'obsHistoryList')}
                >
                  CLOSE
                </button>
              </div>
            ]}
           >
            <div className="container-fluid emrfrm">
                <div className="row">
                    <div className="col-12">
                      <div className="table-responsive">
                        <table className="table table-bordered" id="obstetric-table">
                          <thead>
                            <tr>
                              <th className="text-center">YEAR</th>
                              <th className="text-center">MODE OF CONCEPTION</th>
                              <th className="text-center">PREGNANCY TYPE</th>
                              <th className="text-center">INDICATION FOR C-SECTION</th>
                              <th className="text-center">DETAILS</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.prevAncCardData.map((data, i) => (
                              <tr key={i}>
                                <td className="text-center">{data.pregnancy_year}</td>
                                <td className="text-center">{data?.delivery_mode === "1" ? "Natural" : data?.delivery_mode === "2" ? "IVF" : data?.delivery_mode === "3" ? "IUI" : ''}</td>
                                <td className="text-center">{data?.pregnancy_type == "1" ? "Single" : data?.pregnancy_type == "2" ? "Multiple" : data?.pregnancy_type == "3" ? "Ectopic" : ''}{ data.pregnancy_type == "2" ? " (" + data?.multiple_pregnancies?.length + ")": "" }</td>
                                <td className="text-center">{data.delivery_indication_for_c_section}</td>
                                <td className="text-center">{data.delivery_details}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                </div>
            </div>
          </Modal>
      </Fragment> 
		);
	}
}

export default ObsGynaeComponentSS;